'use client';
import { MoveRight } from 'lucide-react';
import { motion } from 'motion/react';
import { Orbitron } from 'next/font/google';
import Link from 'next/link';
import { InView } from '@/components/ui/in-view';
import { MagicCard } from '@/components/ui/magic-card';
import { cn } from '@/utils/utils';

const orbitron = Orbitron({
    variable: '--font-orbitron',
    subsets: ['latin'],
});
const ProjectsSection = ({ projects }) => {
    return (
        <section className='flex min-h-screen w-full flex-col items-center justify-center sm:grid-cols-2 lg:grid-cols-3'>
            <InView
                viewOptions={{ once: false, margin: '0px 0px -250px 0px' }}
                variants={{
                    hidden: {
                        opacity: 0,
                    },
                    visible: {
                        opacity: 1,
                        transition: {
                            staggerChildren: 0.18,
                        },
                    },
                }}>
                <h1 className={cn('mb-20 w-full text-center text-4xl', orbitron.className)}>
                    Projects
                </h1>
                <div className='grid gap-x-8 gap-y-12 sm:grid-cols-2 lg:grid-cols-3'>
                    {projects.map(project => (
                        <ProjectCard key={project.id} {...project} />
                    ))}
                </div>
            </InView>
        </section>
    );
};

export default ProjectsSection;

interface IProjectCardProps {
    topTitle: string;
    title: string;
    body: string;
    btnText: string;
    btnLink: string;
}
const ProjectCard = (props: IProjectCardProps) => {
    const { topTitle, title, body, btnText, btnLink } = props;
    return (
        <motion.div
            variants={{
                hidden: { opacity: 0, scale: 0.8, filter: 'blur(10px)' },
                visible: {
                    opacity: 1,
                    scale: 1,
                    filter: 'blur(0px)',
                },
            }}
            className='flex h-full min-w-96 max-w-96 flex-col border'>
            <MagicCard gradientColor={'#262626'} className='flex h-full w-full flex-col'>
                <h2 className='w-full border-b px-2 py-2 text-[#ABB2BF]'>{topTitle}</h2>
                <div className='flex min-h-60 flex-col items-start justify-between p-4'>
                    <h2 className='text-2xl'>{title}</h2>
                    <p className='text-[#ABB2BF]'>{body}</p>
                    <Link
                        className='group flex w-fit items-center justify-center gap-x-3 whitespace-nowrap border px-4 py-2 text-center'
                        href={btnLink}
                        data-umami-event='project-click'
                        data-umami-event-project={title}
                        data-umami-event-url={btnLink}>
                        {btnText}
                        <MoveRight className='duration-1000 animate-out repeat-infinite group-hover:translate-x-1' />
                    </Link>
                </div>
            </MagicCard>
        </motion.div>
    );
};
